import WanderCRS from '../../models/WanderCRS'
import { Point } from '../../models/BasicTypes'

export default class MapObjectCRS {
  private wanderCRS: WanderCRS
  private pixelOrigin: Point
  private zoomLevel: number

  constructor (wanderCRS: WanderCRS, pixelOrigin: Point, zoomLevel: number) {
    this.wanderCRS = wanderCRS
    this.pixelOrigin = pixelOrigin
    this.zoomLevel = zoomLevel
  }

  /**
   * Convert given point in wander CRS to relative pixel position for web
   * element in leaftlet layer
   * @param point point in wnader CRS
   * @returns point in map pixel CRS relative to pixel origin
   */
  wanderToRelative (point: Point): Point {
    // absolute pixel position in the map
    const pixelPosition = this.wanderCRS.wanderToPixel(point, this.zoomLevel)
    // relative position to pixel origin
    return {
      x: Math.floor(pixelPosition.x - this.pixelOrigin.x),
      y: Math.floor(pixelPosition.y - this.pixelOrigin.y)
    }
  }

  /**
   * Convert given point in relative pixel position CRS to wander CRS
   * @param point point in pixel CRS relative to pixel origin
   * @returns point in wander CRS
   */
  relativeToWander (point: Point): Point {
    // absolute pixel position in the map
    const wanderPosition = this.wanderCRS.pixelToWander(
      {
        x: point.x + this.pixelOrigin.x,
        y: point.y + this.pixelOrigin.y
      },
      this.zoomLevel
    )
    return wanderPosition
  }

  /**
   * Converg given point in wander CRS to Z-index for the web element in
   * leaftlet layer
   * @param point
   */
  wanderToZIndex (point: Point): number {
    const relativePosition = this.wanderToRelative(point)
    return Math.floor(relativePosition.y)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MapObjects/MapObjectCRS.ts